module.exports = __webpack_public_path__ + "img/discount.736abe35.webp";